(() => {
  const VERSION = '1.0.2';
  if (window.PBWCBMobileConversionV1?.version === VERSION) return;

  const norm = v => String(v || '').toLowerCase().replace(/×/g, 'x').replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim();
  const routeFor = v => {
    v = norm(v);
    if (v.includes('blank') || v.startsWith('no')) return 'blank';
    if (v.includes('pre-made') || v.includes('premade') || v.includes('template')) return 'template';
    if (v.includes('send your design') || v.includes('upload') || v.includes('own artwork')) return 'upload';
    return 'unknown';
  };
  const labelFor = (v, short = false) => {
    const r = routeFor(v);
    if (r === 'blank') return 'Blank Box';
    if (r === 'template') return short ? 'Pre-Made Design' : 'Personalize with one of our designs';
    if (r === 'upload') return short ? 'Upload Your Design' : 'Upload your own design';
    return v || 'Choose personalization';
  };

  const init = root => {
    if (!root || root.dataset.pbWcbConversionV1) return null;
    root.dataset.pbWcbConversionV1 = VERSION;
    root.classList.add('pb-wcb-v1');
    document.body.classList.add('pb-wcb-v1-ready');

    const sid = root.dataset.sectionId || '';
    const productInfo = document.getElementById(`ProductInfo-${sid}`) || root.parentElement;
    const sizeSec = root.querySelector('[data-pb-wedding-size-section]');
    const persSec = root.querySelector('[data-pb-wedding-personalization-section]');
    const colorHead = root.querySelector('[data-pb-wedding-color-heading]');
    const nativePicker = root.querySelector('.pb-wedding-inline__native-picker');
    const designGrid = root.querySelector('[data-pb-design-grid]');
    const designs = [...root.querySelectorAll('[data-pb-design-button]')];
    const vinylSec = root.querySelector('[data-pb-wedding-vinyl-section]');
    const vinylPanels = [...root.querySelectorAll('[data-pb-vinyl-panel]')];
    const vinylTabs = [...root.querySelectorAll('[data-pb-vinyl-tab]')];
    const vinyls = [...root.querySelectorAll('[data-pb-vinyl-button]')];
    const details = root.querySelector('[data-pb-personalization-details]');
    const artwork = root.querySelector('[data-pb-artwork-file]');
    const designProp = root.querySelector('[data-pb-design-property]');
    const vinylProp = root.querySelector('[data-pb-vinyl-property]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-pb-wedding-variants]')?.textContent || '[]'); } catch (_) {}

    const incoming = new URL(location.href).searchParams.get('variant');
    const deepVariant = incoming ? variants.find(v => String(v.id) === String(incoming)) : null;
    const state = {
      deep: !!deepVariant,
      size: !!deepVariant,
      color: !!deepVariant,
      pers: !!deepVariant,
      edit: '',
      designsOpen: false,
      colorsOpen: false,
      suppress: false,
      designOpened: false,
      addAt: 0,
      lastColor: ''
    };

    const groups = () => {
      const el = document.getElementById(`variant-selects-${sid}`);
      const gs = el ? [...el.querySelectorAll(':scope > .product-form__input')] : [];
      const find = terms => gs.find(g => {
        const t = norm(g.querySelector('legend,.form__label,label')?.textContent);
        return terms.some(term => t.includes(term));
      }) || null;
      return { size: find(['size']), color: find(['color']), pers: find(['personalization', 'personalisation', 'personal']) };
    };
    const selected = g => g?.querySelector('input[type="radio"]:checked')?.value || g?.querySelector('select')?.value || '';
    const read = () => {
      const g = groups();
      return { size: selected(g.size), color: selected(g.color), pers: selected(g.pers) };
    };
    const currentVariant = () => {
      const x = read();
      const wanted = [x.size, x.color, x.pers].map(norm);
      return variants.find(v => wanted.every((value, i) => norm(v.options?.[i]) === value)) || null;
    };
    const selectNative = (g, value) => {
      if (!g) return false;
      const wanted = norm(value);
      const radio = [...g.querySelectorAll('input[type="radio"]')].find(i => norm(i.value) === wanted);
      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      const select = g.querySelector('select');
      const option = select ? [...select.options].find(o => norm(o.value) === wanted && !o.disabled) : null;
      if (!option) return false;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };

    const detail = extra => {
      const x = read(), v = currentVariant();
      return Object.assign({
        productHandle: 'linen-wedding-card-box',
        productId: variants[0]?.product_id || null,
        variantId: v?.id || null,
        size: x.size || null,
        color: x.color || null,
        personalization: labelFor(x.pers, true),
        personalizationRaw: x.pers || null,
        design: root.querySelector('[data-pb-design-button].is-active')?.dataset.pbDesignNumber || null,
        designColor: root.querySelector('[data-pb-vinyl-button].is-active')?.dataset.pbVinylName || null,
        stage: root.dataset.pbWcbStage || null
      }, extra || {});
    };
    const emit = (name, extra) => window.dispatchEvent(new CustomEvent(name, { detail: detail(extra) }));

    const valueStrip = document.createElement('div');
    valueStrip.className = 'pb-wcb-v1__value-strip';
    valueStrip.dataset.pbWcbValueStrip = '';
    valueStrip.innerHTML = '<div><strong>Rigid linen-covered construction</strong></div><div><strong>7 standard sizes</strong><span>7.5-in card slot</span></div><div><strong>Digital mock-up</strong><span>Before personalized production</span></div><div><strong>Made to order</strong><span>In North Carolina</span></div>';
    root.prepend(valueStrip);

    let summary = root.querySelector('[data-pb-wcb-selected-summary]');
    if (!summary) {
      summary = document.createElement('section');
      summary.className = 'pb-wcb-v1__selected-summary';
      summary.dataset.pbWcbSelectedSummary = '';
      summary.hidden = true;
      summary.innerHTML = '<div class="pb-wcb-v1__selected-summary-heading"><span>Your selected box</span><strong>Ready to continue</strong></div><dl><div><dt>Size</dt><dd data-pb-wcb-summary-size></dd><button type="button" data-pb-wcb-change="size" aria-label="Change box size">Change</button></div><div><dt>Linen</dt><dd data-pb-wcb-summary-color></dd><button type="button" data-pb-wcb-change="color" aria-label="Change linen color">Change</button></div><div><dt>Personalization</dt><dd data-pb-wcb-summary-pers></dd><button type="button" data-pb-wcb-change="personalization" aria-label="Change personalization">Change</button></div></dl>';
      valueStrip.after(summary);
    }

    let colorSec = root.querySelector('[data-pb-wcb-color-section]');
    if (!colorSec) {
      colorSec = document.createElement('section');
      colorSec.className = 'pb-wedding-inline__step pb-wcb-v1__color-section pb-wcb-v1__core-step';
      colorSec.dataset.pbWcbColorSection = '';
      if (colorHead) colorSec.append(colorHead);
      if (nativePicker) colorSec.append(nativePicker);
    }
    sizeSec?.classList.add('pb-wcb-v1__core-step');
    persSec?.classList.add('pb-wcb-v1__core-step');
    summary.after(sizeSec);
    sizeSec?.after(colorSec);
    colorSec.after(persSec);

    const setText = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };
    setText(sizeSec?.querySelector('.pb-wedding-inline__step-number'), '1');
    setText(colorHead?.querySelector('.pb-wedding-inline__step-number'), '2');
    setText(persSec?.querySelector('.pb-wedding-inline__step-number'), '3');
    setText(sizeSec?.querySelector('.pb-wedding-inline__step-heading h2'), 'Choose your box size');
    setText(sizeSec?.querySelector('.pb-wedding-inline__step-heading p'), 'Seven standard sizes are available. Open the dimensions guide to compare shape and footprint.');
    setText(colorHead?.querySelector('h2'), 'Choose your linen color');
    setText(colorHead?.querySelector('p'), 'Choose the linen color for your box.');
    setText(persSec?.querySelector('.pb-wedding-inline__step-heading h2'), 'Choose your finish');
    setText(persSec?.querySelector('.pb-wedding-inline__step-heading p'), 'Choose a blank box, personalize with one of our designs, or upload your own finished design.');
    persSec?.querySelectorAll('[data-pb-wedding-option-button]').forEach(b => setText(b.querySelector('.pb-wedding-inline__personalization-copy strong'), labelFor(b.dataset.pbOptionValue)));

    const designToggle = document.createElement('button');
    designToggle.type = 'button';
    designToggle.className = 'pb-wcb-v1__expand-toggle';
    designToggle.dataset.pbWcbDesignToggle = '';
    designGrid?.after(designToggle);

    const colorToggle = document.createElement('button');
    colorToggle.type = 'button';
    colorToggle.className = 'pb-wcb-v1__expand-toggle pb-wcb-v1__expand-toggle--finish';
    colorToggle.dataset.pbWcbFinishToggle = '';
    const disclaimer = vinylSec?.querySelector('.pb-wedding-inline__vinyl-disclaimer');
    if (disclaimer) disclaimer.before(colorToggle); else vinylSec?.append(colorToggle);

    const chosenDesign = () => root.querySelector('[data-pb-design-button].is-active')?.dataset.pbDesignNumber || designProp?.value || '';
    const chosenVinyl = () => root.querySelector('[data-pb-vinyl-button].is-active')?.dataset.pbVinylName || vinylProp?.value || '';
    const renderDisclosure = () => {
      const activeDesign = String(chosenDesign()).replace(/\D/g, '').padStart(2, '0');
      designs.forEach((b, i) => b.classList.toggle('pb-wcb-v1__choice-hidden', !state.designsOpen && i >= 6 && b.dataset.pbDesignNumber !== activeDesign));
      setText(designToggle, state.designsOpen ? 'Show fewer designs' : `View all designs (${designs.length})`);
      designToggle.setAttribute('aria-expanded', String(state.designsOpen));
      const activeVinyl = chosenVinyl();
      vinylPanels.forEach(p => [...p.querySelectorAll('[data-pb-vinyl-button]')].forEach((b, i) => b.classList.toggle('pb-wcb-v1__choice-hidden', !state.colorsOpen && i >= 6 && b.dataset.pbVinylName !== activeVinyl)));
      setText(colorToggle, state.colorsOpen ? 'Show fewer colors' : 'View all colors');
      colorToggle.setAttribute('aria-expanded', String(state.colorsOpen));
    };

    const ensureDimensions = () => {
      const modal = document.getElementById(`PBWeddingDimensionsModal-${sid}`) || document.querySelector('[data-pb-dimensions-modal]');
      const dialog = modal?.querySelector('[data-pb-dimensions-dialog]');
      if (!dialog || dialog.querySelector('[data-pb-wcb-dimensions-guide]')) return;
      dialog.querySelector('.pb-wedding-inline__dimensions-image-error')?.setAttribute('aria-hidden', 'true');
      const guide = document.createElement('div');
      guide.className = 'pb-wcb-v1__dimensions-guide';
      guide.dataset.pbWcbDimensionsGuide = '';
      guide.innerHTML = '<div class="pb-wcb-v1__dimensions-guide-intro"><strong>All standard sizes use a 7.5-inch card and envelope slot.</strong><span>Measurements are Length × Width × Height. Actual usable inside space is slightly smaller than the outside dimensions.</span></div><div class="pb-wcb-v1__dimensions-size-list"><div><strong>10 × 6 × 10 in</strong><span>Shallowest depth and smallest table footprint in the square-front group.</span></div><div><strong>10 × 8 × 10 in</strong><span>More front-to-back space while keeping a 10-inch square front.</span></div><div><strong>10 × 10 × 10 in</strong><span>Deepest square-front option and the most internal space in that group.</span></div><div><strong>10 × 10 × 6 in</strong><span>Broad square footprint with the lowest height.</span></div><div><strong>10 × 10 × 8 in</strong><span>Square footprint with more height and internal space.</span></div><div><strong>12 × 10 × 8 in</strong><span>Wide rectangular option.</span></div><div><strong>12 × 12 × 8 in</strong><span>Largest standard footprint.</span></div></div><p class="pb-wcb-v1__dimensions-note">Card capacity varies with envelope and card thickness, so there is no fixed guest-count capacity.</p><button type="button" class="pb-wcb-v1__dimensions-return" data-pb-wcb-dimensions-return>Back to choosing size</button>';
      dialog.append(guide);
      guide.querySelector('[data-pb-wcb-dimensions-return]')?.addEventListener('click', () => {
        modal.querySelector('[data-pb-dimensions-close]')?.click();
        setTimeout(() => { state.edit = 'size'; sync(); sizeSec?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 220);
      });
    };

    const dock = () => document.querySelector('body > [data-pb-wedding-purchase-dock]') || document.querySelector('[data-pb-wedding-purchase-dock]');
    const render = () => {
      const x = read();
      const complete = state.size && state.color && state.pers;
      root.dataset.pbWcbSizeConfirmed = String(state.size);
      root.dataset.pbWcbColorConfirmed = String(state.color);
      root.dataset.pbWcbPersonalizationConfirmed = String(state.pers);
      root.dataset.pbWcbCoreComplete = String(complete);
      root.dataset.pbWcbEdit = state.edit;
      root.dataset.pbWcbArrival = state.deep ? 'variant-deep-link' : 'generic';
      colorSec.hidden = !state.size;
      if (persSec) persSec.hidden = !state.color;
      summary.hidden = !complete;
      setText(summary.querySelector('[data-pb-wcb-summary-size]'), x.size || '—');
      setText(summary.querySelector('[data-pb-wcb-summary-color]'), x.color || '—');
      setText(summary.querySelector('[data-pb-wcb-summary-pers]'), labelFor(x.pers, true));

      if (!state.size) root.querySelectorAll('[data-pb-option-type="size"].is-active').forEach(b => b.setAttribute('aria-pressed', 'false'));

      const r = state.pers ? routeFor(x.pers) : 'none';
      const detailsField = details?.closest('.pb-wedding-inline__field');
      detailsField?.classList.toggle('pb-wcb-v1__deferred-detail', r === 'template' && !chosenDesign());
      const deferVinyl = r === 'blank' || r === 'none' || (r === 'template' && (!chosenDesign() || !String(details?.value || '').trim())) || (r === 'upload' && !artwork?.files?.length);
      vinylSec?.classList.toggle('pb-wcb-v1__deferred-detail', deferVinyl);
      if (r === 'template' && state.pers && !state.designOpened) {
        state.designOpened = true;
        emit('pb:wcb:design_selector_opened', { source: state.deep ? 'deep-link' : 'user' });
      }
      renderDisclosure();
      ensureDimensions();

      const d = dock(), a = d?.querySelector('[data-pb-dock-action]');
      setText(d?.querySelector('[data-pb-dock-size]'), state.size ? x.size : 'Choose size');
      setText(d?.querySelector('[data-pb-dock-color]'), state.color ? x.color : 'Choose color');
      if (a) {
        if (!state.size) { a.textContent = 'Choose Size'; a.dataset.action = 'pb-size'; a.disabled = false; root.dataset.pbWcbStage = 'size'; }
        else if (!state.color) { a.textContent = 'Choose Color'; a.dataset.action = 'pb-color'; a.disabled = false; root.dataset.pbWcbStage = 'color'; }
        else if (!state.pers) { a.textContent = 'Choose Personalization'; a.dataset.action = 'pb-personalization'; a.disabled = false; root.dataset.pbWcbStage = 'personalization'; }
        else root.dataset.pbWcbStage = a.dataset.action === 'add' ? 'add-to-cart' : (a.dataset.action || 'review');
      }

      const url = new URL(location.href);
      if (complete) {
        const v = currentVariant();
        if (v?.id) url.searchParams.set('variant', String(v.id));
      } else url.searchParams.delete('variant');
      const next = `${url.pathname}${url.search}${url.hash}`;
      const now = `${location.pathname}${location.search}${location.hash}`;
      if (next !== now) history.replaceState(history.state, '', next);
      installDock();
    };

    let timer = 0;
    const sync = () => {
      queueMicrotask(render);
      requestAnimationFrame(render);
      clearTimeout(timer);
      timer = setTimeout(render, 120);
      setTimeout(render, 340);
    };

    const confirm = (type, value) => {
      if (type === 'size') {
        state.size = true; if (state.edit === 'size') state.edit = '';
        emit('pb:wcb:size_selected', { source: 'user', selectedValue: value });
        sync(); if (!state.color) setTimeout(() => colorSec.scrollIntoView({ behavior: 'smooth', block: 'center' }), 120);
      } else if (type === 'personalization') {
        state.pers = true; if (state.edit === 'personalization') state.edit = '';
        emit('pb:wcb:personalization_path_selected', { source: 'user', path: routeFor(value), selectedValue: labelFor(value, true) });
        sync();
      }
    };

    root.addEventListener('click', e => {
      const change = e.target.closest('[data-pb-wcb-change]');
      if (change) {
        e.preventDefault();
        state.edit = change.dataset.pbWcbChange;
        render();
        (state.edit === 'size' ? sizeSec : state.edit === 'color' ? colorSec : persSec)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const option = e.target.closest('[data-pb-wedding-option-button]');
      if (option && !state.suppress && !option.disabled) confirm(option.dataset.pbOptionType, option.dataset.pbOptionValue || '');
      const design = e.target.closest('[data-pb-design-button]');
      if (design && !state.suppress) { emit('pb:wcb:design_selected', { source: 'user', design: design.dataset.pbDesignNumber || null }); sync(); }
      const vinyl = e.target.closest('[data-pb-vinyl-button]');
      if (vinyl && !state.suppress) { emit('pb:wcb:finish_selected', { source: 'user', finish: vinyl.dataset.pbVinylFinish || null, designColor: vinyl.dataset.pbVinylName || null }); sync(); }
    }, true);

    const confirmColor = value => {
      value = value || read().color;
      if (state.color && norm(state.lastColor) === norm(value)) return sync();
      state.color = true; state.lastColor = value; if (state.edit === 'color') state.edit = '';
      emit('pb:wcb:color_selected', { source: 'user', selectedValue: value });
      sync(); if (!state.pers) setTimeout(() => persSec?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 120);
    };
    root.addEventListener('click', e => {
      if (state.suppress) return;
      const g = groups().color;
      if (!g) return;
      const input = e.target.closest('input[type="radio"]');
      const label = e.target.closest('label');
      if (input && g.contains(input)) confirmColor(input.value);
      else if (label && g.contains(label)) {
        const linked = label.htmlFor ? document.getElementById(label.htmlFor) : null;
        confirmColor(linked?.value || label.textContent);
      }
    }, true);
    root.addEventListener('change', e => { if (!state.suppress && groups().color?.contains(e.target)) confirmColor(e.target.value); sync(); }, true);

    designToggle.addEventListener('click', () => { state.designsOpen = !state.designsOpen; renderDisclosure(); if (state.designsOpen) emit('pb:wcb:extended_design_list_opened', { source: 'user' }); });
    colorToggle.addEventListener('click', () => { state.colorsOpen = !state.colorsOpen; renderDisclosure(); if (state.colorsOpen) emit('pb:wcb:extended_finish_list_opened', { source: 'user' }); });
    details?.addEventListener('input', sync);
    artwork?.addEventListener('change', sync);
    vinylTabs.forEach(t => t.addEventListener('click', () => { state.colorsOpen = false; sync(); }));

    const installDock = () => {
      const a = dock()?.querySelector('[data-pb-dock-action]');
      if (!a || a.dataset.pbWcbCapture) return;
      a.dataset.pbWcbCapture = VERSION;
      a.addEventListener('click', e => {
        const action = a.dataset.action;
        if (action === 'pb-size' || action === 'pb-color' || action === 'pb-personalization') {
          e.preventDefault(); e.stopImmediatePropagation();
          state.edit = action.replace('pb-', ''); render();
          (action === 'pb-size' ? sizeSec : action === 'pb-color' ? colorSec : persSec)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (action === 'add') { state.addAt = Date.now(); emit('pb:wcb:add_to_cart_attempted', { source: 'dock' }); }
      }, true);
    };

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, payload => {
          if (!state.addAt || Date.now() - state.addAt > 15000) return;
          state.addAt = 0;
          emit('pb:wcb:add_to_cart_succeeded', { source: payload?.source || 'shopify-cart-update', productVariantId: payload?.productVariantId || currentVariant()?.id || null });
        });
      }
    } catch (_) {}

    if (deepVariant) {
      state.suppress = true;
      const opts = deepVariant.options || [], g = groups();
      if (opts[0] && norm(selected(g.size)) !== norm(opts[0])) selectNative(g.size, opts[0]);
      if (opts[1] && norm(selected(g.color)) !== norm(opts[1])) selectNative(g.color, opts[1]);
      const p = [...(persSec?.querySelectorAll('[data-pb-wedding-option-button]') || [])].find(b => norm(b.dataset.pbOptionValue) === norm(opts[2]));
      p?.click();
      setTimeout(() => { state.suppress = false; state.size = state.color = state.pers = true; sync(); }, 0);
    }

    new MutationObserver(sync).observe(productInfo || root, { childList: true, subtree: true });
    document.addEventListener('variant:change', sync);
    window.addEventListener('pageshow', sync);
    window.addEventListener('popstate', sync);

    renderDisclosure(); ensureDimensions(); installDock(); sync();
    emit('pb:wcb:customizer_started', { source: deepVariant ? 'variant-deep-link' : 'generic' });
    return { root, state, sync, read, currentVariant };
  };

  const contexts = [...document.querySelectorAll('[data-pb-wedding-inline]')].map(init).filter(Boolean);
  window.PBWCBMobileConversionV1 = { version: VERSION, active: !!contexts.length, contexts, refresh: () => contexts.forEach(c => c.sync()) };
})();
